module.exports = __webpack_public_path__ + "img/49a95090005da55b1a92da03744395e1.png";